module.exports = __webpack_public_path__ + "img/相続税かんたん計算.9c8c947c.png";